// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async'; // Ensure this import is correct
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext'; // Adjust path
// Import the service worker registration
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// Your CSS imports (Bootstrap, Slick, global custom CSS)
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.css'; // Your global custom styles file (create if it doesn't exist)
// import './App.css'; // If App.css contains global styles, otherwise it's usually imported in App.js

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <HelmetProvider> {/* <--- THIS IS THE CRUCIAL WRAPPER --- */}
      <AuthProvider>
        <App />
      </AuthProvider>
    </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// CHANGE THIS from unregister() to register() to enable PWA caching and install prompts

serviceWorkerRegistration.register();

reportWebVitals();